import { useIntl } from "react-intl";
import useFormatter from "../../hooks/useFormatter";

import GroupItem from "./GroupItem";

import { ReactComponent as DotsSVG } from "../../assets/dots-vertical-thin.svg";
import { ReactComponent as GroupIconSVG } from "../../assets/group-icon.svg";

import GroupInterface from "../../interfaces/GroupInterface";

import { useOutletContext } from "react-router-dom";
import { MainPageOutletContext } from "../main/Main";
import "./group.scss";

function Group({ group }: { group: GroupInterface }) {
  const { formatElectricity } = useFormatter();
  const { formatMessage } = useIntl();
  const outlet = useOutletContext<MainPageOutletContext>();

  const { id, name, limit, currentlyUsed, allDeviceCount, activeDeviceCount } =
    group;

  return (
    <GroupItem
      to={outlet.generatePath("/group/:groupId/edit", { groupId: id })}
      className="device-group"
    >
      <div className="content">
        <div className="title">{name}</div>
        <div className="energy-limit">
          <div className="limit">
            <div className="value">{formatElectricity(limit)}</div>
            <div className="text">
              {formatMessage({ id: "group.card.limit" })}
            </div>
          </div>
          <div className="separator" />
          <div className="used">
            <div className="value">{formatElectricity(currentlyUsed)}</div>
            <div className="text">
              {formatMessage({ id: "group.card.electricity_used" })}
            </div>
          </div>
        </div>
        <div className="devices">
          {formatMessage(
            { id: "group.card.active_devices" },
            {
              current: activeDeviceCount,
              total: allDeviceCount,
            }
          )}
        </div>
      </div>
      <div className="icon">
        <GroupIconSVG />
      </div>
      <div className="settings">
        <DotsSVG />
      </div>
    </GroupItem>
  );
}

export default Group;
